import { Box, Text, useColorMode } from "theme-ui";
import { FilterValue, GraphMonthData } from "../../../../../types/dashboard.types";
import ProjectProgressionChart from "./chart2";
import React from "react";

const ProjectProgression = ({
    popoverRef,
    months,
    graphData,
    loading,
    progressionChartFilterValue,
    isPopoverOpen,
    handleProjectProgressionFilterClick,
    togglePopover,
    showMonthYearPicker,
    toggleYearMonthHandle,
    handleAllMonthSelection,
    handleAllYearSelection,
}: {
    popoverRef: any
    months: string[] | null | undefined;
    graphData: GraphMonthData[] | null | undefined;
    loading: boolean;
    progressionChartFilterValue: FilterValue
    isPopoverOpen: string | null;
    handleProjectProgressionFilterClick: any;
    togglePopover: any;
    showMonthYearPicker: boolean;
    toggleYearMonthHandle: any
    handleAllMonthSelection: any;
    handleAllYearSelection: any,
}) => {

    const [colorMode] = useColorMode();
    const bgGeographic = colorMode === 'light' ? "#ffffff" : "#2e354db8";
    const bgDashboard = colorMode === 'light' ? "#ffffff" : "#323c56";
    const titleHeader = colorMode === 'light' ? "#453521" : "#f8f9fa";
    const MONTH_ORDER = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December",
    ];
    const MONTH_INDEX: Record<string, number> = {
        January: 0, February: 1, March: 2, April: 3,
        May: 4, June: 5, July: 6, August: 7,
        September: 8, October: 9, November: 10, December: 11,
    };



    const allGraphData = React.useMemo(() => {
        if (!Array.isArray(graphData) || graphData.length === 0) {
            return graphData;
        }

        const mode = progressionChartFilterValue.progressionTime;

        /* ---------------- HISTORIC ---------------- */
        if (mode === "Historic") {
            const lastYear = Number(graphData[graphData.length - 1].month);
            const futureYears = 12;

            const normalized = [...graphData];

            for (let i = 1; i <= futureYears; i++) {
                normalized.push({
                    month: String(lastYear + i),
                    done: 0,
                    approved: 0,
                    cumulativeApproved: 0,
                });
            }

            return normalized;
        }

        /* ---------------- YTD ---------------- */
        if (mode === "YTD") {
            return MONTH_ORDER.map((month) => {
                const found = graphData.find(d => d.month === month);

                return (
                    found ?? {
                        month,
                        done: 0,
                        approved: 0,
                        cumulativeApproved: 0,
                    }
                );
            });
        }
        if (mode === "Custom Selection") {
            let lastEntry = graphData[graphData.length - 1].month.split(" ");
            let lastYear = lastEntry[1];
            const futureYears = 12;
            const normalized = [...graphData];
            const selectedMonths = [...progressionChartFilterValue.progressionMonths].sort((a, b) => MONTH_INDEX[a] - MONTH_INDEX[b]);
            const selectedYears = progressionChartFilterValue.progressionYears;
            if (selectedMonths.length > 0 && selectedYears.length === 0) {
                for (let i = 1; i <= futureYears; i++) {
                    for (let j = 0; j < selectedMonths.length; j++) {
                        let monthLabel = selectedMonths[j] + " " + String(Number(lastYear) + i);
                        let found = normalized.find(d => d.month === monthLabel);
                        if (!found) {
                            normalized.push({
                                month: monthLabel,
                                done: 0,
                                approved: 0,
                                cumulativeApproved: 0,
                            });
                        }
                    }
                }
            }

            return normalized;
        }


        return graphData;
    }, [graphData]);





    return (
        <Box sx={{ bg: bgGeographic, borderRadius: "20px", p: "20px" }}>
            <Text as={"h4"} sx={{ fontSize: ["12px", "14px", "16px", "18px"], fontWeight: 700, color: titleHeader }}>Project Progression Over Time</Text>
            <Box sx={{ borderRadius: "20px", boxShadow: "box-shadow: 0px 0px 40px 0px rgba(209, 173, 138, 0.12)", mt: "20px" }}>
                <ProjectProgressionChart popoverRef={popoverRef} graphData={allGraphData} loading={loading} value={progressionChartFilterValue} isPopoverOpen={isPopoverOpen} handleProjectProgressionFilterClick={handleProjectProgressionFilterClick} togglePopover={togglePopover} months={months} showMonthYearPicker={showMonthYearPicker} toggleYearMonthHandle={toggleYearMonthHandle} handleAllMonthSelection={handleAllMonthSelection} colorMode={colorMode} handleAllYearSelection={handleAllYearSelection} />
            </Box>
        </Box>
    );
};

export default React.memo(ProjectProgression);
